import Model from '@nozbe/watermelondb/Model'
import { text } from '@nozbe/watermelondb/decorators'

export interface ISnooze {
  id: string
  fireAt: number
  title: string
  body: string
  tag: string
}

export default class Snooze extends Model implements ISnooze {
  static table = 'Snooze'

  @text('fireAt') fireAt!: number
  @text('title') title!: string
  @text('body') body!: string
  @text('tag') tag!: string
}
